/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Pending_DescriptionInputs */

const en_orders_review_pending_description = /** @type {(inputs: Orders_Review_Pending_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manager has not reviewed the order yet.`)
};

const es_orders_review_pending_description = /** @type {(inputs: Orders_Review_Pending_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El gerente aun no revisa el pedido.`)
};

/**
* | output |
* | --- |
* | "Manager has not reviewed the order yet." |
*
* @param {Orders_Review_Pending_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_pending_description = /** @type {((inputs?: Orders_Review_Pending_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Pending_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_pending_description(inputs)
	return es_orders_review_pending_description(inputs)
});